module.exports = __webpack_public_path__ + "static/media/estrellaDammGlassCatalan.f9800b47.jpg";